import {Link} from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import {AES, enc} from "crypto-js";
import {Suspense, useEffect, useState} from "react";
import {toast, ToastContainer} from "react-toastify";
import Header from "../Header";
import Button from "../component-assets/Button";
import ApiRequester from "../ApiRequester";
import {
    convertIsoToLocal,
    convertSectoHHMM,
    formatDateIso,
    iAmHigherAuthority,
    formCheck,
    formFail,
    formSuccess,
    getLocalTimeFromEpochMillis,
    getToday,
    handleSubmitActions,
    HHMMtoLocalTime,
    setDeviceFilters,
    toggleCollapse,
    showModal,
    isBannerPresent,
    sortFunc,
    paginateData
} from "../../libs";
import MaterialIcon from "material-icons-react";
import {Chart, registerables} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import TableBody from "../component-assets/TableBody";
import TableHeaders from "../component-assets/TableHeaders";
import Navigation from "../Navigation";
import SearchableDropdown from "../component-assets/SearchableDropdown";
import PerPageModal from "../component-assets/PerPageModal";
import {Pagination} from "react-bootstrap";
import PaginationItems from "../component-assets/PaginationItems";
import HourlyLineAndBarChart from "../charts/HourlyLineAndBarChart";
import LineTrendingChart from "../charts/LineTrendingChart";
import ProfileSkeleton from "../component-assets/skeletons/ProfileSkeleton";

const InovonicsDevice = (props) => {
    let dData, bData, startDate, endDate, eventHeaderData, noteHeaderData, logHeaderData;

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), process.env.REACT_APP_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    Chart.register(...registerables);
    Chart.register(annotationPlugin);

    eventHeaderData = [
        {label: "Event Start", key: "event_datetime_local", align: "center", sorts: false,
            link: {enabled: true, linkto: "/profiles/event", linkkey: "event_id", type: "datetime"}},
        {label: "Response Time (min)", key: "response_time", align: "center", sorts: false},
        {label: "Resident", key: "resident_name", align: "left", sorts: false,
            link: {enabled: true, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id"}},
        {label: "Location", key: "area_name", align: "left", sorts: false,
            link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
        {label: "Reason", key: "reason_code_description", align: "center", type: "indicator", sorts: false,
            indicator: {enabled: dData?.is_reason_editable, type: "length", key: "reason_edits",
                title: "This value has been edited"}}
    ];

    noteHeaderData = [
        {label: "Timestamp", key: "create_time", align: "center", type: "datetime-utc", sorts: false},
        {label: "Created By", key: "display_name", align: "center", sorts: false},
        {label: "Note", key: "note", align: "left", sorts: false},
    ]

    logHeaderData = [
        {label: "Timestamp", key: "create_time", align: "center", type: "datetime-utc", sorts: false},
        {label: "Log Event", key: "device_log_type_name", align: "center", sorts: false, filtered: true}
    ]

    // Permission Variables
    const [editRights, setEditRights] = useState(iAmHigherAuthority(10, dData.role_weight));
    const [read, setRead] = useState(true);
    // Main Page Variables
    const [deviceId, setDeviceId] = useState(props?.id);
    const [count, setCount] = useState(0);
    const [repCount, setRepCount] = useState(0);
    const [campusId, setCampusId] = useState(dData.acnt);
    const [tabItem, setTabItem] = useState("init");
    const [storedIndex, setStoredIndex] = useState(0);
    const [prenoteData, setPrenoteData] = useState([]);
    const [prenoteOptions, setPrenoteOptions] = useState([]);
    // Load Variables
    const [basicDataLoaded, setBasicDataLoaded] = useState(false); // Goes into Basic
    const [resLoaded, setResLoaded] = useState(false); // Goes into Basic
    const [areaLoaded, setAreaLoaded] = useState(false); // Goes into Basic
    const [useMapLoaded, setUseMapLoaded] = useState(false); // Goes into Basic
    const [basicLoaded, setBasicLoaded] = useState(false); // Handles Basic Tab Display
    const [hourDataLoaded, setHourDataLoaded] = useState(false); // Goes into Report
    const [weekDataLoaded, setWeekDataLoaded] = useState(false); // Goes into Report
    const [eventDataLoaded, setEventDataLoaded] = useState(false); // Goes into Report
    const [reasonDataLoaded, setReasonDataLoaded] = useState(false); // Goes into Report
    const [reportLoaded, setReportLoaded] = useState(false); // Handles Report Tab Display
    const [careDataLoaded, setCareDataLoaded] = useState(false); // Goes into Wellness
    const [wellnessLoaded, setWellnessLoaded] = useState(false); // Handles Wellness Tab Display
    const [logDataLoaded, setLogDataLoaded] = useState(false); // Goes into Logs
    const [logsLoaded, setLogsLoaded] = useState(false); // Handles Logs Tab Display
    const [debugDataLoaded, setDebugDataLoaded] = useState(false);
    const [troubleLoaded, setTroubleLoaded] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    // LineTrendingVariables
    const [lineData, setLineData] = useState([]);
    const [lineColors, setLineColors] = useState([]);
    const [lineLabels, setLineLabels] = useState([]);
    const [lineAxisLabels, setLineAxisLabels] = useState([]);
    // Basic Information Variables
    const [basicData, setBasicData] = useState([]);
    const [debugData, setDebugData] = useState([]);
    const [areaData, setAreaData] = useState([]);
    const [residentData, setResidentData] = useState([]);
    const [areaGroups, setAreaGroups] = useState([]);
    const [resGroups, setResGroups] = useState([]);
    const [serialNum, setSerialNum] = useState("");
    const [description, setDescription] = useState("");
    const [residentId, setResidentId] = useState(0);
    const [areaId, setAreaId] = useState(0);
    const [deviceImg, setDeviceImg] = useState("");
    const [isActive, setIsActive] = useState(0);
    const [deviceTypeId, setDeviceTypeId] = useState(0);
    const [deviceType, setDeviceType] = useState("");
    const [isAreaDevice, setIsAreaDevice] = useState("");
    const [useMapData, setUseMapData] = useState([]);
    // Reporting Variables
    const [weekData, setWeekData] = useState({});
    const [hourData, setHourData] = useState({});
    const [reasonData, setReasonData] = useState({});
    const [reasonRows, setReasonRows] = useState([]);
    const [eventData, setEventData] = useState([]);
    const [eventTableRows, setEventTableRows] = useState([]);
    const [noteTableRows, setNoteTableRows] = useState([]);
    const [noteTableLength, setNoteTableLength] = useState(0);
    // Logging Variables
    const [logOriginData, setLogOriginData] = useState([]);
    const [logActiveData, setLogActiveData] = useState([]);
    const [logTableRows, setLogTableRows] = useState([]);
    const [logHeaderFilters, setLogHeaderFilters] = useState([]);
    const [logSorter, setLogSorter] = useState({
        sortColumn: "create_time",
        sortOrder: "desc"
    });
    const [logPPRules, setLogPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [logPage, setLogPage] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [storePage, setStorePage] = useState(1);
    const [tmpPerPage, setTmpPerPage] = useState(dData.perPage);
    // Wellness Variables
    const [areaWellData, setAreaWellData] = useState([]);
    const [careData, setCareData] = useState([]);
    const [careflow, setCareflow] = useState([]);

    startDate = formatDateIso(getToday(-28));
    endDate = formatDateIso(getToday());

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", payload: {device_filter: deviceId, campus_id: campusId},
                          procedure: "getinovonicsdeviceprofile", reqType: "stored", "read-only": read}).then(data => {
                setBasicData(data?.length > 0 ? data[0] : {});
                setBasicDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                procedure: "sp_dev_getareasbycampusid", reqType: "stored", "read-only": true}).then(data => {
                setAreaData(data ? data : []);
                setAreaLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": true,
                                procedure: "sp_dev_getresidentsbycampusid", reqType: "stored"}).then(data => {
                setResidentData(data ? data : []);
                setResLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", "read-only": true,
                          payload: {campus_id: campusId, care_types: "1,3,4,5", care_event_types: "1"},
                          procedure: "getcareflowwindows", reqType: "stored"}).then(data => {
                setCareData(data);
                setCareDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "device_id", pVal: deviceId,
                            procedure: "getdevicelogs", reqType: "stored", "read-only": true}).then(data => {
                setLogOriginData(data);
                setLogDataLoaded(true);
            });
            setRead(true);
            setCount(() => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        if (![basicLoaded, reportLoaded, wellnessLoaded, logsLoaded].includes(false)){
            setPageLoaded(true);
        }
    }, [basicLoaded, reportLoaded, wellnessLoaded, logsLoaded]);

    useEffect(() => {
        if (![basicDataLoaded, resLoaded, areaLoaded, useMapLoaded].includes(false)){
            setBasicLoaded(true);
            if (tabItem === "init") {
                setTabItem("basic");
            }
        }
    }, [basicDataLoaded, resLoaded, areaLoaded, useMapLoaded]);

    useEffect(() => {
        if ([hourDataLoaded, weekDataLoaded, eventDataLoaded, reasonDataLoaded].every((item) => item === true)){
            setReportLoaded(true);
        }
    }, [hourDataLoaded, weekDataLoaded, eventDataLoaded, reasonDataLoaded]);

    useEffect(() => {
        if ([debugDataLoaded].every((item) => item === true)){
            setTroubleLoaded(true);
        }
    }, [debugDataLoaded]);

    useEffect(() => {
        if ([careDataLoaded, basicDataLoaded].every((item) => item === true)){
            setWellnessLoaded(true);
        }
    }, [careDataLoaded, basicDataLoaded]);

    useEffect(() => {
        if ([logDataLoaded].every((item) => item === true)){
            setLogsLoaded(true);
        }
    }, [logDataLoaded]);

    useEffect(() => {
        if (areaData.length > 0){
            setAreaData(areaData.sort((a, b) => sortFunc(a, b, "area_name", "asc")));
        }
    }, [areaData]);

    useEffect(() => {
        // Performs realtime search of data as location types.
        let tmpData, input, pRules;

        tmpData = logOriginData.filter(item => {
            return Object.keys(logHeaderFilters).every(key => {
                if (!logHeaderFilters[key] || logHeaderFilters[key].length === 0) return true;
                return logHeaderFilters[key].includes(String(item[key]));
            });
        });

        pRules = paginateData(tmpData, logPage, perPage);
        if (input && logPage > pRules.pageMax){
            setLogPage(pRules.pageMax);
        }else if (!input){
            setLogPage(storePage);
        }
        setLogPRules(pRules);
        setLogActiveData(tmpData);
    }, [logOriginData, logHeaderFilters]);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setRepCount(repCount => repCount - 1);
        }, 1000);
        if (repCount <= 0){
            {dData?.event_notes_active && dData.event_notes_preform &&
                ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "core_preform_event_notes",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": read}).then(data => {
                    setPrenoteData(data);
                });
            }
            ApiRequester({reqEndpoint: "get-mysql-report", rep_type: "dashboardhourchart",
                                campus_id: campusId, device_filter: deviceId.toString()}).then(data => {
                setHourData(data);
                setHourDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "get-mysql-report", rep_type: "dashboardweekchart",
                                campus_id: campusId, device_filter: deviceId.toString()}).then(data => {
                setWeekData(data);
                setWeekDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "get-mysql-report", rep_type: "eventReasonSummary",
                        campus_id: campusId, start_date: startDate, end_date: endDate,
                        device_category_filter: "", area_type_filter: "", reason_filter: "", user_filter: "",
                        event_type_filter: "", resident_filter: "", device_filter: deviceId.toString()}).then(data => {
                setReasonData(() => data ? data : []);
                setReasonDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", payload: {campus_id: campusId, device_id: deviceId.toString()},
                                procedure: "getlimitedevents", reqType: "stored", "read-only": true}).then(data => {
                setEventData(data);
                setEventDataLoaded(true);
            });
            setRead(true);
            setRepCount(repCount => 1200);
        }
        return () => clearInterval(interval);
    }, [repCount]);

    useEffect(() => {
        if (Object.keys(basicData).length > 0){
            if (basicData?.manufacture_uuid){
                ApiRequester({reqEndpoint: "getitems", Table: "DebugSerialNumber", PKey: "SerialNum", CampusId: campusId,
                                    PVal: basicData.manufacture_uuid.toString()}).then(data => {
                    let tmpData = []
                    for (let i=0; i < data.length; i++){
                        data[i].Parsed = JSON.parse(data[i]?.Parsed);
                        tmpData.push(data[i]);
                    }
                    setDebugData(tmpData ? tmpData : []);
                    setDebugDataLoaded(true);
                });
            }
            setAreaGroups(() => basicData?.area_groups ? basicData.area_groups : []);
            setResGroups(() => basicData?.resident_groups ? basicData.resident_groups : []);
            setIsActive(() => basicData?.is_active ? basicData.is_active : 0);
            setDescription(() => basicData?.descriptions ? basicData.descriptions : "");
            setAreaId(() => basicData?.area_id ? basicData.area_id : 0);
            setResidentId(() => basicData?.resident_id ? basicData.resident_id : 0);
            setSerialNum(() => basicData?.manufacture_uuid ? basicData.manufacture_uuid : "");
            setDeviceImg(basicData?.image_url ? basicData?.image_url : "");
            setDeviceType(basicData?.device_type_name ? basicData.device_type_name : "");
            setIsAreaDevice(basicData?.device_type === "location");
            setDeviceTypeId(basicData?.device_type_id ? basicData.device_type_id : 0);
            setBasicLoaded(true);
            ApiRequester({reqEndpoint: "myfetch", pKey: "inovonics_type_id", pVal: basicData.device_type_id,
                                Tbl: "att_inovonics_use_entity",
                                procedure: "fetchbyparameter", reqType: "direct"}).then(data => {
                setUseMapData(data ? data : []);
                setUseMapLoaded(true);
            });
        }
    }, [basicData]);

    useEffect(() => {
        formCheck("basic-form", "save-basic-btn")
    }, [areaId]);

    useEffect(() => {
        let tmpAflows = [], tmpDflows = [], tmpDevflows = [], tmpRflows = [], allFlows;
        if (careData?.length > 0){
            for (let i=0; i < careData?.length; i++){
                if (careData[i].escalation_type_id === 1){
                    tmpDflows.push(<>
                        <div key={`cfd-1-${i}`} className={"d-inline-block"} style={{minWidth: "175px", maxWidth: "175px", textOverflow: "ellipsis"}}>
                            {careData[i].careflow_description}
                        </div>
                        <div key={`cft-1-${i}`} className={"d-inline-block align-top ms-1"}>
                            {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_start))} - {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_end))} (Default)
                        </div>
                    </>);
                }else if (careData[i].escalation_type_id === 3){
                    if (careData[i]?.references.split(",").includes(deviceId.toString())){
                        tmpDevflows.push(<>
                            <div key={`cfd-3-${i}`} className={"d-inline-block"} style={{minWidth: "175px", maxWidth: "175px", textOverflow: "ellipsis"}}>
                                {careData[i].careflow_description}
                            </div>
                            <div key={`cft-3-${i}`} className={"d-inline-block align-top ms-1"}>
                                {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_start))} - {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_end))} (Device)
                            </div>
                        </>);
                    }
                }else if (careData[i].escalation_type_id === 4){
                    for (let i2=0; i2 < resGroups?.length; i2++){
                        if (careData[i]?.references.split(",").includes(resGroups[i2]?.resident_group_id?.toString())){
                            tmpRflows.push(<>
                                <div key={`cfd-4-${i}`} className={"d-inline-block"} style={{minWidth: "175px", maxWidth: "175px", textOverflow: "ellipsis"}}>
                                    {careData[i].careflow_description}
                                </div>
                                <div key={`cft-4-${i}`} className={"d-inline-block align-top ms-1"}>
                                    {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_start))} - {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_end))} (Resident)
                                </div>
                            </>);
                        }
                    }
                }else if (careData[i].escalation_type_id === 5){
                    for (let i3=0; i3 < areaGroups?.length; i3++){
                        if (careData[i]?.references.split(",").includes(areaGroups[i3]?.area_group_id?.toString())){
                            tmpAflows.push(<>
                                <div key={`cfd-5-${i}`} className={"d-inline-block"} style={{minWidth: "175px", maxWidth: "175px", textOverflow: "ellipsis"}}>
                                    {careData[i].careflow_description}
                                </div>
                                <div key={`cft-5-${i}`} className={"d-inline-block align-top ms-1"}>
                                    {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_start))} - {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_end))} (Area)
                                </div>
                            </>);
                        }
                    }
                }
            }
            allFlows = tmpDevflows.concat(tmpRflows, tmpAflows, tmpDflows);
            setCareflow(allFlows.map((item, i) => {return <div key={`cf-item-${i}`}>{item}<br/></div>}));
        }
    }, [careData, resGroups, areaGroups]);

    useEffect(() => {
        let tmp = [];
        if (prenoteData.length > 0){
            for (let i=0; i < prenoteData.length; i++){
                tmp.push(
                    <option key={`prenote-option-${i}`} value={prenoteData[i]?.preform_note}>{prenoteData[i]?.preform_note}</option>
                );
            }
        }
        if (dData?.event_notes_freeform){
            tmp.push(
                <option key={`prenote-option-00`} value={"0"}>Other (freeform note)</option>
            );
        }
        setPrenoteOptions(() => tmp);
    }, [prenoteData]);

    useEffect(() => {
        if (dData?.event_notes_active){
            setEventTableRows(<TableBody start={0} end={eventData.length} tableData={eventData} checkbox={false}
                                         writeAccess={true} unk={"dev-"} modalType={"add"} modalLabel={"Add Note"}
                                         actionAppearance={() => {}} parentComponent={"InovonicsDevice"}
                                         tableHeaders={eventHeaderData} modal={true} editModal={addNoteModal}
                                         dData={dData} checkboxlist={[]} editModalBadge={"notes"}
                                         setCheckboxId={() => {}} checkidkey={""} />);
        }else{
            setEventTableRows(<TableBody start={0} end={eventData.length} tableData={eventData} checkbox={false}
                                         writeAccess={true} unk={"dev-"} modalType={"add"} modalLabel={"Add Note"}
                                         actionAppearance={() => {}} parentComponent={"InovonicsDevice"}
                                         tableHeaders={eventHeaderData} modal={false} editModal={() => {}}
                                         dData={dData} checkboxlist={[]} editModalBadge={"notes"}
                                         setCheckboxId={() => {}} checkidkey={""} />);
        }
    }, [eventData]);

    useEffect(() => {
        let pRules = paginateData(logActiveData, logPage, perPage);
        setLogPRules(pRules);
        if (logActiveData.length > 0) {
            logActiveData.sort((a, b) => sortFunc(a, b, logSorter.sortColumn, logSorter.sortOrder));
        }
        setLogTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={logActiveData} checkbox={false}
                                writeAccess={false} unk={"l-"} addlEditKey={""} addlEditCheck={false}
                                actionAppearance={() => {}}
                                tableHeaders={logHeaderData} editModal={() => {}} parentComponent={"InovonicsDevice"} dData={dData}
                                modal={false} checkboxlist={[]} setCheckboxId={() => {}}
                                tzOffset={parseInt(dData?.campusData[campusId]?.tz_offset ? dData?.campusData[campusId]?.tz_offset : 0)}
                                checkidkey={""} />);
    }, [logActiveData, logSorter, logPage, perPage]);

    useEffect(() => {
        if (weekData){
            setLineColors(["#0081C7"]);
            setLineLabels(["Total Alarms"]);
            setLineData([weekData?.events?.length > 0 ? weekData.events : []]);
            setLineAxisLabels(weekData?.labels?.length > 0 ? weekData.labels : []);
        }
    }, [weekData]);

    function basicActionHandling(){
        document.getElementById("description-static").classList.toggle("d-none");
        document.getElementById("description-edit").classList.toggle("d-none");
        document.getElementById("serialnum-static").classList.toggle("d-none");
        document.getElementById("serialnum-edit").classList.toggle("d-none");
        document.getElementById("linked-static")?.classList?.toggle("d-none");
        document.getElementById("linked-edit-div")?.classList?.toggle("d-none");
        document.getElementById("behavior-static")?.classList?.toggle("d-none");
        document.getElementById("behavior-edit")?.classList?.toggle("d-none");
        if (document.getElementById("edit-basic-btn").innerText === "Edit"){
            document.getElementById("edit-basic-btn").innerText = "Cancel";
            document.getElementById("save-basic-btn").classList.toggle("d-none");
            document.getElementById("serialnum-edit").value = basicData?.manufacture_uuid;
            document.getElementById("description-edit").value = basicData?.descriptions;
            document.getElementById("behavior-edit").value = basicData.device_use_id;
        }else{
            document.getElementById("edit-basic-btn").innerText = "Edit";
            document.getElementById("save-basic-btn").classList.toggle("d-none");
        }
        formCheck("basic-form", "save-basic-btn");
    }

    function basicSubmit(){
        let description, linkedId, payload, serialnum, oldPayload, useId;
        if (editRights){
            handleSubmitActions("save-basic-btn", "load-basic-btn");
            description = document.getElementById("description-edit").value;
            linkedId = isAreaDevice ? areaId : residentId;
            useId = document.getElementById("behavior-edit").value;
            serialnum = parseInt(document.getElementById("serialnum-edit").value);
            payload = [{device_id: parseInt(deviceId), descriptions: description, is_active: linkedId !== 0,
                        area_id: basicData?.is_area_device === 1 ? parseInt(linkedId) : 0, device_use_id: parseInt(useId),
                        resident_id: basicData?.is_resident ? parseInt(linkedId) : 0,
                        manufacture_uuid: serialnum.toString(), modified_by: dData.user,
                        offsite: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_active,
                        offsite_id: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_id}];
            oldPayload = [{device_id: parseInt(deviceId), descriptions: description, is_active: isActive ? 1 : 0,
                           area_id: areaId, resident_id: residentId, manufacture_uuid: serialNum}];
            ApiRequester({reqEndpoint: "mytransaction", TransType: "device_edit_basic", Payload: payload,
                                CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                ClientId: dData.sessionId}).then(data => {
                if (data && data[0]){
                    setRead(false);
                    setCount(0);
                    formSuccess("Basic information saved.", "save-basic-btn", "load-basic-btn", "edit-basic-btn")
                }
                else{
                    formFail(`Error during save, error code: ${data && data?.length > 1 ? data[1] : ""}`,
                        "save-basic-btn", "load-basic-btn");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function addNoteModal(rowIndex){
        let dataIndex;
        dataIndex = parseInt(rowIndex);
        setStoredIndex(dataIndex);
        document.getElementById("note").value = "";
        setNoteTableLength(eventData[dataIndex].notes.length);
        setNoteTableRows(<TableBody start={0} end={eventData[dataIndex].notes.length}
                                    tableData={eventData[dataIndex].notes} checkbox={false}
                                     writeAccess={false} unk={"n-"} actionAppearance={() => {}}
                                     tableHeaders={noteHeaderData} modal={false}
                                     parentComponent={"Event"} dData={dData} checkboxlist={[]}
                                     setCheckboxId={() => {}} checkidkey={"note_id"}
                                     tzOffset={parseInt(dData?.campusData[campusId]?.tz_offset ? dData?.campusData[campusId]?.tz_offset : 0)}/>);
        formCheck("addNoteForm", "addNoteSubmit");
        showModal("addnotemodal");
    }

    function addNoteSubmit(){
        let payload, eventId, note;
        handleSubmitActions("addNoteSubmit", "loadAddNoteSubmit");
        eventId = eventData[storedIndex]?.event_id;
        note = document.getElementById("note").value;
        if (note === "0"){
            note = document.getElementById("note-freeform").value;
        }
        payload = [{event_id: eventId, campus_id: dData.acnt, note: note, modified_by: dData?.user}];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_event_notes", Payload: payload, urlType: "PUT",
                            User: dData.user, PKey: "note_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId}).then(data => {
            if (data[0] === true){
                formSuccess(`Note added successfully.`, "addNoteSubmit", "loadAddNoteSubmit", "cancelAddNoteBtn", "addNoteForm");
                setRead(false);
                setRepCount(0);
                document.getElementById("submitBtn").click()
            }
            else{
                formFail(`Error during add, error code: ${data[1]}`, "addNoteSubmit", "loadAddNoteSubmit");
            }
        });
    }

    function performLogging(){
        let msg, payload, logTime;
        handleSubmitActions("log-btn", "load-log-btn");
        logTime = document.getElementById("logtimer").value;
        payload = [{manufacture_uuid: basicData?.manufacture_uuid, duration: parseInt(logTime)}];
        ApiRequester({reqEndpoint: "mqtt", Operation: "deviceLogging", CampusId: campusId,
                            ClientId: dData.sessionId, Payload: payload}).then(data => {
            if(data[0]){
                msg = "Logging has begun, refresh screen or come back later to see newest logs.";
                formSuccess(msg, "log-btn", "load-log-btn");
            }
            else{
                msg = "Error occured starting the logging process with local server. Check server and contact customer support if issue does not resolve.";
                formFail(msg, "log-btn", "load-log-btn");
            }
        });
    }

    function filterSubmit() {
        handleSubmitActions("filterSubmit", "loadFilterSubmit");
        setPerPage(tmpPerPage);
        dData.perPage = tmpPerPage;
        setLogPage(1);
        ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), process.env.REACT_APP_ESECRET).toString());
        formSuccess("Page parameters stored to session.", "filterSubmit",
            "loadFilterSubmit", "cancelFilterBtn");
        setCount(0);
    }

    const eventTableHeaders = <TableHeaders checkbox={false} headerData={eventHeaderData} checkAll={() => {}}
                                            writeAccess={true} sortOrder={""}
                                            checkboxHeaderId={"uCheckHead"} sortColumn={""} sorter={{}}
                                            setSorter={() => {}} modal={dData?.event_notes_active} modal_name={"Notes"} checkboxlist={[]}
                                            actionAppearance={() => {}}/>
    const notesTableHeaders = <TableHeaders checkbox={false} headerData={noteHeaderData}
                                            checkAll={() => {}} writeAccess={editRights} sortOrder={"asc"}
                                            sortColumn={"create_time"} sorter={{}}
                                            setSorter={() => {}} modal={false} checkboxlist={[]}
                                            actionAppearance={() => {}}/>
    const logTableHeaders = <TableHeaders checkbox={false} headerData={logHeaderData} checkAll={() => {}}
                                          writeAccess={false} sortOrder={logSorter.sortOrder} modal_name={""}
                                          originData={logOriginData} headerFiltersOn={true}
                                          sortColumn={logSorter.sortColumn} sorter={logSorter} setSorter={setLogSorter}
                                          modal={false} checkboxlist={[]} actionAppearance={() => {}}
                                          headerFilters={logHeaderFilters} setHeaderFilters={setLogHeaderFilters} setPage={setLogPage}/>

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
        </div>
    );

    return (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Device Profile"}
                        Title={basicData?.manufacture_uuid ? `${basicData?.device_name} (${basicData.manufacture_uuid})` : "Device Missing"}
                        content={headerContent}/>
                <div className={"container-fluid"}>
                    <div className={"col"}>
                        <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                            <li key={"set-basic"} className={"nav-item"}>
                                <Button text={"Basic Info"} spinner={!basicLoaded}
                                        class={tabItem === "basic" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("basic")}/>
                            </li>
                            <li key={"set-reporting"} className={"nav-item"}>
                                <Button text={"Reporting"} spinner={!reportLoaded}
                                        class={tabItem === "reporting" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("reporting")}/>
                            </li>
                            <li key={"set-wellness"} className={"nav-item"}>
                                <Button text={"Wellness"} spinner={!wellnessLoaded}
                                        class={tabItem === "wellness" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("wellness")}/>
                            </li>
                            {iAmHigherAuthority(80, dData?.role_weight)
                                ?   <li key={"set-logs"} className={"nav-item"}>
                                        <Button text={"Device Logs"} spinner={!logsLoaded}
                                                class={tabItem === "logs" ? "nav-link active" : "nav-link"}
                                                onClick={() => setTabItem("logs")}/>
                                    </li>
                                :   <></>
                            }
                            {iAmHigherAuthority(80, dData?.role_weight)
                                ?   <li key={"set-debug"} className={"nav-item"}>
                                        <Button text={"Troubleshoot"} spinner={!troubleLoaded}
                                                class={tabItem === "debug" ? "nav-link active" : "nav-link"}
                                                onClick={() => setTabItem("debug")}/>
                                    </li>
                                :   <></>
                            }
                        </ul>
                    </div>
                    <div className={tabItem === "init" ? "d-block" : "d-none"}>
                        <ProfileSkeleton />
                    </div>
                    <div className={tabItem === "basic" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "550px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"}>Basic Information</h3>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"basic-card-btn"}
                                       onClick={() => toggleCollapse("basic-card-btn", "basic-card")}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"basic-card"}>
                                {deviceImg && <div className={"d-inline-block align-top"}
                                                   style={{
                                                       borderRadius: "8px",
                                                       backgroundColor: "#f9fbfd",
                                                       width: "auto"
                                                   }}>
                                    <img className={"align-top"}
                                         style={{
                                             width: "inherit",
                                             height: "inherit",
                                             padding: "4px",
                                             borderRadius: "8px",
                                             maxHeight: "275px"
                                         }}
                                         src={`${process.env.PUBLIC_URL}/static/image/${deviceImg}`} alt={""}/>
                                </div>}
                                <form className={"d-inline align-top form-control-plaintext was-validated"}
                                      id={"basic-form"}>
                                    <div className={"mx-5 mt-2 align-top d-inline-block"} id={"basic-col1-div"}>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Device Name:</p>
                                            <p className={"ms-4"}
                                               id={"name-static"}>{basicData?.device_name ? basicData.device_name : ""}</p>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px", maxWidth: "175px"}}>Description:</p>
                                            <p className={"ms-4"}
                                               id={"description-static"}>{basicData?.descriptions ? basicData.descriptions : ""}</p>
                                            <input className={"ms-4 d-none form-control form-control-sm"}
                                                   style={{height: "30px", width: "256px"}} id={"description-edit"}
                                                   defaultValue={basicData?.descriptions ? basicData.descriptions : ""}
                                                   pattern={"^[0-9a-zA-Z_\\- ]+$"}/>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Category:</p>
                                            <p className={"ms-4"}
                                               id={"category-static"}>{basicData?.device_category ? basicData.device_category : ""}</p>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Device Type:</p>
                                            <p className={"ms-4"}
                                               id={"device-type-static"}>{deviceType}</p>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Behavior:</p>
                                            {basicLoaded && <p className={"ms-4"} style={{maxWidth: "175px"}}
                                                               id={"behavior-static"}>{basicData?.option_text ? basicData.option_text : "Standard"}</p>}
                                            <select className={"ms-4 d-none form-select form-select-sm"}
                                                    onChange={() => formCheck("basic-form", "save-basic-btn")}
                                                    style={{height: "30px", width: "256px"}}
                                                    id={"behavior-edit"} required={true}
                                                    defaultValue={basicData?.device_use_id ? basicData.device_use_id : 0}>
                                                {useMapData.map((uItem, i) => {
                                                    return <option key={`behavior-item-${i}`}
                                                                   value={uItem?.inovonics_device_use_id}>{uItem?.option_text ? uItem.option_text : "Standard"}</option>
                                                })}
                                            </select>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Serial Number:</p>
                                            <p className={"ms-4"}
                                               id={"serialnum-static"}>{basicData?.manufacture_uuid ? basicData.manufacture_uuid : ""}</p>
                                            <input className={"ms-4 d-none form-control form-control-sm"}
                                                   required={true}
                                                   style={{height: "30px", width: "256px"}} id={"serialnum-edit"}
                                                   defaultValue={basicData?.manufacture_uuid ? basicData.manufacture_uuid : ""}
                                                   pattern={"^[0-9]+$"}/>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Model Number:</p>
                                            <p className={"ms-4"}
                                               id={"model-name-static"}>{basicData?.inovonics_model_name ? basicData.inovonics_model_name : ""}</p>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Attached To:</p>
                                            {basicLoaded
                                                ? isAreaDevice
                                                    ? <>
                                                        <p className={"ms-4"} id={"linked-static"}><Link
                                                            to={`/profiles/area/${basicData?.area_id}`}>{basicData?.area_name ? basicData.area_name : ""}</Link>
                                                        </p>
                                                        <SearchableDropdown
                                                            dataset={{
                                                                data: areaData,
                                                                label: "area_name",
                                                                value: "area_id"
                                                            }}
                                                            label_name={"Area"}
                                                            onChange={(e) => {
                                                                setAreaId(e);
                                                            }}
                                                            occupancyCheck={false}
                                                            value={areaId}
                                                            divClass={"ms-4 w-100 d-none"}
                                                            clearable={true}
                                                            required={false}
                                                            id={"linked-edit"}
                                                        />
                                                    </>
                                                    : <>
                                                        <p className={"ms-4"} id={"linked-static"}><Link
                                                            to={`/profiles/resident/${basicData?.resident_id}`}>{basicData?.resident_name ? basicData.resident_name : ""}</Link>
                                                        </p>
                                                        <SearchableDropdown
                                                            dataset={{
                                                                data: residentData,
                                                                label: "resident_name",
                                                                value: "resident_id"
                                                            }}
                                                            label_name={"Resident"}
                                                            onChange={(e) => {
                                                                setResidentId(e);
                                                            }}
                                                            value={residentId}
                                                            clearable={true}
                                                            divClass={"ms-4 w-100 d-none"}
                                                            required={false}
                                                            id={"linked-edit"}
                                                        />
                                                    </>
                                                : <></>
                                            }
                                        </div>
                                    </div>
                                    <div className={"mx-5 mt-2 d-inline-block align-top"} id={"basic-col2-div"}
                                         style={{minWidth: "300px"}}>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "100px"}}>Last Repeater:</p>
                                            <p className={"ms-4"} id={"last-repeater-static"}>
                                                {basicData?.last_repeater ? basicData.last_repeater : "No Record"}
                                            </p>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "100px"}}>Last Alarmed:</p>
                                            <p className={"ms-4"} id={"last-alarm-static"}>
                                                {basicData?.last_alarm ? convertIsoToLocal(basicData.last_alarm) : "No Record"}
                                            </p>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "100px"}}>Last Active:</p>
                                            <p className={"ms-4"} id={"last-active-static"}>
                                                {basicData?.last_active ? convertIsoToLocal(basicData.last_active) : "No Record"}
                                            </p>
                                        </div>
                                        {[1, 28].includes(deviceTypeId)
                                            ? <div className={"d-flex"}>
                                                <p style={{minWidth: "100px"}}>Last Temp:</p>
                                                <p className={"ms-4"} id={"last-temp-static"}>
                                                    {basicData?.current_temperature ? basicData.current_temperature + "\xB0F" : ""}
                                                </p>
                                            </div>
                                            : <></>
                                        }
                                        {[28].includes(deviceTypeId)
                                            ? <div className={"d-flex"}>
                                                <p style={{minWidth: "100px"}}>Last Humidity:</p>
                                                <p className={"ms-4"} id={"last-humidity-static"}>
                                                    {basicData?.current_humidity ? basicData.current_humidity + "%" : ""}
                                                </p>
                                            </div>
                                            : <></>
                                        }
                                        {[1].includes(deviceTypeId)
                                            ? <div className={"d-flex"}>
                                                <p style={{minWidth: "100px"}}>Battery:</p>
                                                {basicData?.current_battery ? (
                                                    <>
                                                        <div className={"ms-4"}
                                                             style={{display: 'inline-block', verticalAlign: 'middle'}}>
                                                            <MaterialIcon
                                                                icon={
                                                                    parseFloat(basicData.current_battery) >= 2.8 ? "battery_full" :
                                                                        parseFloat(basicData.current_battery) === 2.7 ? "battery_5_bar" :
                                                                            [2.5, 2.6].includes(parseFloat(basicData.current_battery)) ? "battery_2_bar" :
                                                                                "battery_alert"
                                                                }
                                                                color={
                                                                    parseFloat(basicData.current_battery) >= 2.8 ? "#0000008a" :
                                                                        parseFloat(basicData.current_battery) === 2.7 ? "#0000008a" :
                                                                            [2.5, 2.6].includes(parseFloat(basicData.current_battery)) ? "#EAC452" :
                                                                                "#BB271A"
                                                                }
                                                                title={
                                                                    parseFloat(basicData.current_battery) >= 2.8 ? `Battery Full ${basicData.current_battery}V` :
                                                                        parseFloat(basicData.current_battery) === 2.7 ? `Battery Good ${basicData.current_battery}V` :
                                                                            [2.5, 2.6].includes(parseFloat(basicData.current_battery)) ? `Battery Low ${basicData.current_battery}V` :
                                                                                `Battery Critically Low ${basicData.current_battery}V`
                                                                }
                                                                className={"material-icons md-24 md-dark"}
                                                            />
                                                        </div>
                                                        <span className={"ms-1"}></span>
                                                    </>
                                                ) : ""}
                                            </div>
                                            : <></>
                                        }
                                    </div>
                                </form>
                                {basicLoaded && editRights &&
                                    <>
                                        <Button text={"Edit"} class={"btn btn-primary float-end"} id={"edit-basic-btn"}
                                                disabled={!editRights} onClick={() => {
                                            if (editRights) {
                                                basicActionHandling()
                                            }
                                        }}/>
                                        <Button text={"Save"} class={"btn btn-primary float-end me-3 d-none"}
                                                id={"save-basic-btn"}
                                                disabled={!editRights} onClick={() => {
                                            if (editRights) {
                                                basicSubmit()
                                            }
                                        }}/>
                                        <Button type={"button"} class={"btn btn-primary float-end mx-3 d-none"}
                                                disabled={true}
                                                spinner={true} text={""} id={"load-basic-btn"}/>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "reporting" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "500px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"} style={{minWidth: "80px"}}>
                                        Reporting
                                    </h3>
                                    <div className={"d-none"} style={{display: "inline-block"}}
                                         id={"reporting-header-data"}>
                                        <h3 className={"ms-6 my-0 d-inline-block text-success"}>{!isNaN(hourData?.avgValue) ? hourData.avgValue : "?"} Alert/Week</h3>
                                        <h3 className={"mx-4 my-0 d-inline-block text-success"}>{!isNaN(weekData?.avgValue) ? weekData.avgValue : "?"} Avg/Resp</h3>
                                    </div>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"reporting-card-btn"}
                                       onClick={() => {
                                           toggleCollapse("reporting-card-btn", "reporting-card")
                                           document.getElementById("reporting-header-data").classList.toggle("d-none");
                                       }}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"reporting-card"}>
                                <div className={"row"}>
                                    <Link style={{width: "auto", marginLeft: "auto"}} to={"/reports/alerts/run"} onClick={() => {
                                        setDeviceFilters(dData, deviceId, basicData?.device_name);
                                    }}>
                                        <Button text={"Run Detailed Report"} class={"btn btn-primary mb-4 float-end"}
                                                icon={true} iconClass={"fe fe-arrow-right-circle float-end ms-3"}/>
                                    </Link>
                                </div>
                                <div className={"row"}>
                                    <div className={"chart-container w-50 text-end align-top d-inline-block"}>
                                        {hourDataLoaded
                                            ?
                                            <HourlyLineAndBarChart
                                                style={{maxHeight: "425px"}}
                                                labels={hourData?.labels ? hourData.labels : ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12",
                                                                "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]}
                                                x_axis={true}
                                                x_axis_title={"Time of the Day"}
                                                bar_axis={true}
                                                bar_axis_title={"Total Alarms"}
                                                bar_color={"#0081C7"}
                                                line_axis={true}
                                                line_axis_title={"Average Response Time"}
                                                line_color={"#BE4D25"}
                                                bar_data={hourData?.events ? hourData.events : []}
                                                line_data={hourData?.responses ? hourData.responses : []}
                                                bar_annotation={true}
                                                line_annotation={true}
                                                forceAspect={true}
                                                bar_annotation_value={hourData?.avgValue ? hourData.avgValue : 0}
                                                line_annotation_value={hourData?.avgResp ? hourData.avgResp : 0} />
                                            :
                                            (<div className={"text-center"}>
                                                <Button text={""} class={"border-0 bg-transparent btn"}
                                                        spinner={true}></Button>
                                            </div>)
                                        }
                                    </div>
                                    <div className={"chart-container w-50 text-center align-top d-inline-block"}>
                                        {weekDataLoaded
                                            ?
                                            <LineTrendingChart
                                                style={{maxHeight: "425px"}}
                                                x_axis={true}
                                                x_axis_title={"Weeks"}
                                                line_axis={true}
                                                line_axis_title={"Total Alarms"}
                                                lines={1}
                                                line_color={lineColors}
                                                line_labels={lineLabels}
                                                line_data={lineData}
                                                forceAspect={true}
                                                labels={lineAxisLabels} />
                                            :
                                            (<div className={"text-center"}>
                                                <Button text={""} class={"border-0 bg-transparent btn"}
                                                        spinner={true}></Button>
                                            </div>)
                                        }
                                    </div>
                                </div>
                                <div className={"row mt-5"}>
                                    <div className={"w-50 px-4"}>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead>
                                            <tr>
                                                <th className={"table table-header w-auto py-1"} colSpan={"4"}>
                                                    Event Reason Breakdown
                                                </th>
                                            </tr>
                                            <tr>
                                                <th className={"table table-header w-auto py-1"}>
                                                    Reason
                                                </th>
                                                <th className={"table table-header w-auto py-1"}>
                                                    Total
                                                </th>
                                                <th className={"table table-header w-auto py-1"}>
                                                    % Total Volume
                                                </th>
                                                <th className={"table table-header w-auto py-1"}>
                                                    Average Response (min)
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td className={"ps-1 fw-bold"}>Total Events</td>
                                                <td className={"ps-1 fw-bold text-center"}>{reasonData?.count ? reasonData.count : 0}</td>
                                                <td className={"ps-1 text-right"}></td>
                                                <td className={"ps-1 fw-bold text-center"}>{reasonData?.avg_response_time ? reasonData.avg_response_time : 0.0}</td>
                                            </tr>
                                            {reasonRows}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className={"w-50"} style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover d-sm-table"}>
                                            <thead className={"sticky-table-head"} style={{top: 0, zIndex: 1}}>
                                            {eventTableHeaders}
                                            </thead>
                                            <tbody>
                                            {eventTableRows}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "wellness" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "500px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"}
                                        style={{minWidth: "80px"}}>Wellness</h3>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"wellness-card-btn"}
                                       onClick={() => toggleCollapse("wellness-card-btn", "wellness-card")}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"wellness-card"}>
                                <div className={"ms-4"}>
                                    <div className={"d-block"}>
                                        <div className={"d-inline-block align-top me-4"}
                                             style={{minWidth: "125px"}}>Careflow Plan:
                                        </div>
                                        <div
                                            className={"d-inline-block"}>{careflow && careflow?.length > 0 ? careflow : "No Careflow"}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "logs" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "500px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"}
                                        style={{minWidth: "80px"}}>Device Logs</h3>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"wellness-card-btn"}
                                       onClick={() => toggleCollapse("logs-card-btn", "logs-card")}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"logs-card"}>
                                <table className={"table table-sm table-white table-hover"}>
                                    <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                    {logTableHeaders}
                                    </thead>
                                    <tbody id={"tBody"}>
                                    {logTableRows}
                                    </tbody>
                                </table>
                                <div className={"text-center"}>
                                    <Pagination>
                                        <PaginationItems setPage={setLogPage} page={logPage} beginDot={logPPRules.beginDot}
                                                         endDot={logPPRules.endDot} pageMin={logPPRules.pageMin}
                                                         pageMax={logPPRules.pageMax}
                                                         max={logPPRules.max}/>
                                    </Pagination>
                                    <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage}
                                            onClick={() => showModal("filtermodal")}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "debug" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "500px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"}
                                        style={{minWidth: "80px", width: "175px"}}>Troubleshoot Device</h3>
                                    <div className={"d-none"} style={{display: "inline-block"}}
                                         id={"debug-header-data"}>
                                        <h3 className={"ms-6 my-0 d-inline-block text-success"}>{debugData?.length ? debugData.length : 0} Logs</h3>
                                    </div>
                                </div>
                                <div>
                                    <i className={"fe fe-plus as-btn collapse-toggle p-2"} id={"debug-card-btn"}
                                       onClick={() => {
                                           toggleCollapse("debug-card-btn", "debug-card");
                                           document.getElementById("debug-header-data").classList.toggle("d-none");
                                       }}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"debug-card"}>
                                <div>
                                    <form id={"debugForm"} className={"was-validated"}>
                                        <h4>Local server device logging.</h4>
                                        <div className={"flex form-floating mb-3"} style={{maxWidth: "350px"}}>
                                            <select className={"form-select"} id={"logtimer"} value={undefined}
                                                    required={true}>
                                                <option value={"600"}>10 Minutes</option>
                                                <option value={"1800"}>30 Minutes</option>
                                                <option value={"3600"}>1 Hour</option>
                                                <option value={"10800"}>3 Hours</option>
                                                <option value={"21600"}>6 Hours</option>
                                                <option value={"86400"}>24 Hours</option>
                                            </select>
                                            <label htmlFor={"logtimer"}>Log Time Length</label>
                                        </div>
                                        <Button text={"Start Logging"} class={"btn btn-primary mt-2"} id={"log-btn"}
                                                title={"Starts logging device debug data for troubleshooting, will clear and restart log if logging already running."}
                                                onClick={() => {
                                                    performLogging();
                                                }}/>
                                        <Button type={"button"} class={"btn btn-primary mt-2 d-none"}
                                                disabled={true} spinner={true} text={"Starting. . ."}
                                                id={"load-log-btn"}/>
                                    </form>
                                </div>
                                <table className={"table table-sm mt-4"}>
                                    <thead>
                                    <tr>
                                        <th className={"text-center"}>Timestamp</th>
                                        <th className={"text-center"}>Raw Bytes</th>
                                        <th className={"text-center"}>Alarm 0</th>
                                        <th className={"text-center"}>Alarm 1</th>
                                        <th className={"text-center"}>No Change</th>
                                        <th className={"text-center"}>Reset</th>
                                        <th className={"text-center"}>Stat 1</th>
                                        <th className={"text-center"}>Stat 2</th>
                                        <th className={"text-center"}>Supervision</th>
                                        <th className={"text-center"}>Hop 1st / Count</th>
                                        <th className={"text-center"}>Signal</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {debugData?.length > 0
                                        ? debugData?.map((dItem, index) => {
                                            return <tr key={`debug-row-${index}`}>
                                                <td className={"text-center"}>{getLocalTimeFromEpochMillis(dItem.EventTime, dData?.campusData[campusId.toString()]?.tz_offset)}</td>
                                                <td className={"text-center"}>
                                                    <MaterialIcon className={"material-icons as-btn-2x"} icon={"raw_on"}
                                                                  title={dItem?.ByteString}
                                                                  onClick={() => {
                                                                      toast.info(dItem?.ByteString);
                                                                      navigator?.clipboard?.writeText(dItem?.ByteString);
                                                                  }}/>
                                                </td>
                                                <td className={"text-center"}>{dItem?.Parsed?.alarm0 != null ? dItem.Parsed.alarm0.toString() : "N/A"}</td>
                                                <td className={"text-center"}>{dItem?.Parsed?.alarm1 != null ? dItem.Parsed.alarm1.toString() : "N/A"}</td>
                                                <td className={"text-center"}>{dItem?.Parsed?.noChange != null ? dItem.Parsed.noChange.toString() : "N/A"}</td>
                                                <td className={"text-center"}>{dItem?.Parsed?.reset != null ? dItem.Parsed.reset.toString() : "N/A"}</td>
                                                <td className={"text-center"}>{dItem?.Parsed?.stat1 != null ? dItem.Parsed.stat1.toString() : "N/A"}</td>
                                                <td className={"text-center"}>{dItem?.Parsed?.stat2 != null ? dItem.Parsed.stat2.toString() : "N/A"}</td>
                                                <td className={"text-center"}>{dItem?.Parsed?.supervision != null ? dItem.Parsed.supervision.toString() : "N/A"}</td>
                                                <td className={"text-center"}>
                                                    {dItem?.Parsed?.uuidFirstHop != null ? dItem.Parsed.uuidFirstHop : "N/A"}
                                                    <br/>
                                                    {dItem?.Parsed?.hopCount != null ? dItem.Parsed.hopCount : "N/A"}
                                                </td>
                                                <td className={"text-center"}>{dItem?.Parsed?.signal != null ? dItem.Parsed.signal : "N/A"}</td>
                                            </tr>
                                        })
                                        : <tr>
                                            <td colSpan={11}>No logs to display</td>
                                        </tr>
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"addnotemodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticAddNoteBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title text-capitalize"} id={"staticAddNoteBackdropLabel"}>Add
                                Note</h2>
                            <button type={"button"} className={"btn-close"} id={"addNoteClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <form id={"addNoteForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                {dData?.event_notes_preform
                                    ? <div className={"form-floating d-block"}>
                                        <select className={"form-select form-select my-2"} id={"note"}
                                                required={true}
                                                onChange={(e) => {
                                                    if (e.target.value === "0") {
                                                        document.getElementById("freeform").classList.remove("d-none");
                                                        document.getElementById("note-freeform").required = true;
                                                    } else {
                                                        document.getElementById("note-freeform").required = false;
                                                        document.getElementById("freeform").classList.add("d-none");
                                                    }
                                                    formCheck("addNoteForm", "addNoteSubmit");
                                                }}>
                                            {prenoteOptions}
                                        </select>
                                        <label htmlFor={"note"} className={"form-label"}>Note</label>
                                    </div>
                                    :   <div className={"my-2 form-floating"}>
                                            <textarea className={"form-control pt-5"} id={"note"} required={true}
                                                      style={{height: "125px"}}
                                                      onKeyUp={() => formCheck("addNoteForm", "addNoteSubmit")}>

                                            </textarea>
                                            <label htmlFor={"note"} className={"form-label"}>Note</label>
                                            <div className={"invalid-feedback"}>
                                                Note required
                                            </div>
                                        </div>
                                }
                                <div className={"my-2 form-floating d-none"} id={"freeform"}>
                                    <textarea className={"form-control pt-5"} id={"note-freeform"}
                                              style={{height: "125px"}}
                                              onKeyUp={() => formCheck("addNoteForm", "addNoteSubmit")}>
                                    </textarea>
                                    <label htmlFor={"note-freeform"} className={"form-label"}>Note</label>
                                    <div className={"invalid-feedback"}>
                                        Note required
                                    </div>
                                </div>
                                {noteTableLength > 0
                                    ? <>
                                        <hr/>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                            {notesTableHeaders}
                                            </thead>
                                            <tbody id={"tBody"}>
                                            {noteTableRows}
                                            </tbody>
                                        </table>
                                    </>
                                    : <></>
                                }
                            </div>
                            <div className={"modal-footer"}>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelAddNoteBtn"}
                                            data-bs-dismiss={"modal"}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadAddNoteSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"} id={"addNoteSubmit"}
                                            onClick={() => addNoteSubmit()}>Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <PerPageModal filterSubmit={() => filterSubmit()} tmpPerPage={tmpPerPage}
                                              setTmpPerPage={(sudocode) => setTmpPerPage(sudocode)}
                                              setPage={(sudocode) => setLogPage(sudocode)}/>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
        </>
    );
};

export default InovonicsDevice;